module.exports = __webpack_public_path__ + "static/media/img-bg-header-contact.cf51f0c4.png";